import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Lottie from "lottie-react";

import successAnimation from "../assets/Success.json";
import failureAnimation from "../assets/failure.json";
import loadingAnimation from "../assets/Insider-loading.json";
import { getApiUrl } from "../utils/api";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const merchantOrderID = query.get("merchantOrderID");

  const [status, setStatus] = useState("LOADING");
  const attemptsRef = useRef(0); // ✅ persists across calls
  const maxAttempts = 10; // 10 × 2s = 20s max wait

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const res = await fetch(getApiUrl("check-status"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ merchantOrderID }),
        });

        const data = await res.json();
        console.log(`Attempt ${attemptsRef.current + 1}:`, data.status);

        if (data.status === "SUCCESS") {
          setStatus("SUCCESS");
          setTimeout(() => navigate("/bsk-user"), 2000);
        } else if (data.status === "FAILED") {
          setStatus("FAILED");
          setTimeout(() => navigate("/bsk-user"), 2000);
        } else {
          // PENDING — keep polling
          attemptsRef.current += 1; // ✅ correctly increments
          if (attemptsRef.current < maxAttempts) {
            setTimeout(checkPaymentStatus, 2000);
          } else {
            // Still pending after 20s — show pending, redirect
            setStatus("PENDING");
            setTimeout(() => navigate("/bsk-user"), 2000);
          }
        }
      } catch (err) {
        console.error("Payment status error:", err);
        attemptsRef.current += 1;
        if (attemptsRef.current < maxAttempts) {
          // ✅ Retry even on network error, don't show FAILED immediately
          setTimeout(checkPaymentStatus, 2000);
        } else {
          setStatus("FAILED");
          setTimeout(() => navigate("/bsk-user"), 2000);
        }
      }
    };

    checkPaymentStatus();
  }, [merchantOrderID, navigate]);

  const getAnimation = () => {
    if (status === "LOADING" || status === "PENDING") return loadingAnimation;
    return status === "SUCCESS" ? successAnimation : failureAnimation;
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: "80vh" }}
    >
      <Lottie
        animationData={getAnimation()}
        loop={status === "LOADING" || status === "PENDING"}
        style={{ width: 300, height: 300 }}
      />
      <h3 className="mt-3">
        {status === "SUCCESS"
          ? "Payment Successful!"
          : status === "PENDING"
          ? "Payment Pending..."
          : status === "FAILED"
          ? "Payment Failed!"
          : "Checking Payment..."}
      </h3>
      <p className="text-muted">
        {status === "LOADING"
          ? "Please wait, verifying your payment..."
          : status === "PENDING"
          ? "Taking longer than usual, redirecting..."
          : "Redirecting to your account..."}
      </p>
    </div>
  );
};

export default PaymentStatus;